<template>
  <div :class="componentClassName">
    <a-page-heading>ユーザー管理</a-page-heading>
    <m-section>
      <m-action-card v-if="dataLoaded" title="ユーザー情報編集" icon="user" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-setting-users-edit__form" @submit.prevent="handleFormSubmit">
          <div v-if="userInfo" class="t-setting-users-edit__fields">
            <m-form-input label="ユーザーID">
              <a-text-field id="userIDInput" v-model="userData.userID" type="text" :disabled="true" />
            </m-form-input>
            <m-form-input label="登録名">
              <a-text-field id="usernameInput" v-model="userData.username" type="text" :disabled="!canEditUser" />
            </m-form-input>
            <m-form-input label="部署名（任意）">
              <a-text-field
                id="departmentInfoInput"
                v-model="userData.departmentInfo"
                type="text"
                :disabled="!canEditUser"
              />
            </m-form-input>
            <m-form-input label="システム権限">
              <a-select-field
                id="authInfoSelect"
                v-model="userData.authInfo"
                :options="permissionOptions"
                :disabled="userData.authInfo === 'supervisor' || !canEditUser"
              />
            </m-form-input>
            <!-- <m-form-input label="着信グループ">
              <a-text-field v-model="userData.group" type="text" :disabled="true" />
            </m-form-input> -->
            <!-- <m-form-input label="SMS認証番号">
              <a-text-field v-model="userData.smsNumber" type="text" />
            </m-form-input> -->
            <!-- <m-form-input label="パスワード">
              <a-text-field type="password" :disabled="true" value="xxxxxxxxxx" />
            </m-form-input> -->
            <m-form-input v-if="isDAccountActive">
              <a-switch
                id="dAccountFlagToggle"
                v-model="userData.dAccountFlag"
                label="ビジネスdアカウント連携"
                :disabled="!canEditUser"
              />
            </m-form-input>
            <a-caption-list v-if="canPasswordReset">
              <li>
                パスワード再設定メールをユーザーに送信する場合は
                <a-button id="resetPasswordLink" variant="text" color="primary" :href="'#'" @click="handlePasswordReset"
                  >こちら</a-button
                >
              </li>
            </a-caption-list>
            <m-form-input v-if="sfAvailable" label="Salesforceのユーザ名">
              <a-text-field v-model="sfAuthInfo.userID" placeholder="username@example.com" />
            </m-form-input>
            <m-form-input v-if="sfAvailable" label="Salesforceのパスワード">
              <a-text-field v-model="sfAuthInfo.password" type="password" placeholder="***********" />
            </m-form-input>
            <a-caption-list v-if="sfAvailable">
              <li>{{ sfPasswordCondition }}</li>
            </a-caption-list>
          </div>
          <m-form-action-buttons>
            <a-button
              v-if="userInfo"
              id="saveBtn"
              variant="block"
              color="primary"
              :disabled="!canEditUser"
              @click="checkUserSettings"
              >保存</a-button
            >
            <a-button id="cancelBtn" variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingUsersEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          v-if="resultModalMode === 'normal'"
          id="resultModalOKBtn"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
        <a-button
          v-if="resultModalMode === 'checkUserSettings'"
          id="saveCheckModalOKBtn"
          variant="block"
          color="primary"
          label="保存"
          size="small"
          @click="handleUserEdit"
        />
        <a-button
          v-if="resultModalMode === 'checkUserSettings'"
          id="saveCheckModalCancelBtn"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import ACaptionList from '@/components/atoms/caption-list';
import ASelectField from '@/components/atoms/select-field';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { mapActions } from 'vuex';
import { POINT } from '@/libs/constants';

import { utils } from '@/common/utils.js';

export default {
  name: 't-setting-users-edit',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormActionButtons,
    MFormInput,
    ATextField,
    ACaptionList,
    ASelectField,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dataLoaded: false,
      userData: {
        userID: '',
        companyID: '',
        username: '',
        departmentInfo: '',
        authInfo: '',
        group: '',
        clientName: '',
        phone_number: '',
        dAccountFlag: false,
      },
      userInfo: {},
      authInfo: this.$store.state.user.authInfo,
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      resultModalMode: '',
      selectedCompanyID: '',
      permissionOptions: [
        { value: 'operator', label: 'オペレーター' },
        { value: 'manager', label: '管理者' },
      ],
      isDAccountActive: false,
      canActiveDAccount: false,
      canResetPassword: false,
      isTrialUser: false,

      // Salesforce認証情報
      sfAuthInfo: {
        userID: '',
        password: '',
      },
      sfPasswordCondition:
        'パスワードとセキュリティトークンを1つにつなげて入力してください。（例: パスワードが「password」、セキュリティトークンが「security_token」の場合、「passwordsecurity_token」となります）',
      sfAvailable: false,
      saveSuccessFlag: false, // 保存成功フラグ
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-users-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
    canEditUser() {
      if (this.companyID === POINT) {
        // 003300
        if (this.authInfo === 'soOperator') return false;
        if (this.authInfo === 'operator' && this.selectedCompanyID === POINT) return false;
      } else {
        // 003300以外
        if (this.authInfo === 'operator') return false;
      }
      return true;
    },
    canPasswordReset() {
      if (this.companyID === POINT) {
        // 003300
        if (this.authInfo === 'soOperator' && this.selectedCompanyID !== POINT) return false;
      } else {
        // 003300以外
        if (this.authInfo === 'operator') return false;
      }
      return true;
    },
  },
  mounted() {
    this.selectedCompanyID = this.$route.query.companyID;
    if (!this.canEditUser && !this.canPasswordReset) {
      this.$router.push({ path: '/permission-denied' });
    }
    if (this.selectedCompanyID === POINT) {
      this.permissionOptions = [
        { value: 'operator', label: 'オペレーター（運用保守）' },
        { value: 'soOperator', label: 'オペレーター（SO）' },
        { value: 'manager', label: '管理者' },
      ];
    }
    const userID = this.$route.query.userID;
    if (userID) {
      this.postRequest('/idmgmt/getuserdata', { companyID: this.selectedCompanyID, userID: userID })
        .then(e => {
          if (e.status === 'success') {
            // 企業ID003300のユーザーがビジネスdアカウント連携できない
            this.isDAccountActive = this.selectedCompanyID === POINT ? false : e.isDAccountActive;
            this.userData = e.data;
            this.userData.username = this.userData.username.replace('_', ' ');
            this.userData.userID = userID;
            this.userData.dAccountFlag = !!e.data.dAccountFlag;
            this.canResetPassword = !this.userData.dAccountFlag;
            this.canActiveDAccount = e.canActiveDAccount;

            //TODO: remove when fix all old data
            if (this.userData.authInfo === 'オペレーター') {
              this.userData.authInfo = 'operator';
            } else if (this.userData.authInfo === '管理者') {
              this.userData.authInfo = 'manager';
            }
            if (this.userData.authInfo === 'supervisor') {
              this.permissionOptions = [{ value: 'supervisor', label: 'マスタ管理者' }];
            }
            Object.assign(this.userInfo, this.userData);

            // Salesforceユーザ名を取得
            this.sfAuthInfo.userID = e.data.sfUserID;

            this.dataLoaded = true;
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    }
    // Salesforce連携機能ON・OFFを取得
    this.getSfAvailable(userID, this.selectedCompanyID);
  },
  methods: {
    ...mapActions(['updateLoginInfo']),
    handleFormSubmit(event) {
      event.preventDefault();
      this.handleUserEdit(cloneDeep(this.userData));
    },
    checkUserSettings() {
      if (this.sfAvailable === true) {
        // Salesforceユーザー名が入力されている状態でSalesforceパスワードが空白の場合はモーダル表示
        if (this.sfAuthInfo.userID && !this.sfAuthInfo.password) {
          this.resultModalVisible = true;
          this.resultModalMode = 'checkUserSettings';
          this.resultModalTitle = messageContent.userSettingsCheckModalTitle;
          this.resultModalContent = messageContent.emptySfPasswordMessage;
        } else {
          this.handleUserEdit();
        }
      } else {
        this.handleUserEdit();
      }
    },
    handleUserEdit() {
      // 保存前にモーダルを非表示
      this.handleCloseModal();

      if (!this.userData.username) {
        this.showErrorModal(messageContent.requireInput('登録名'));
        return;
      } else if (this.hasSpecialCharacterInObject(this.userData)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      } else if (this.userData.username.length > 41) {
        this.showErrorModal(messageContent.requireUnderMaximumNumberOfCharacters('ユーザー名', 41));
        return;
      }
      // Length check for department
      const lengthCheck = this.departmentNameLengthCheck(this.userData.departmentInfo);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return;
      }
      // Underbar check for username
      const underbarCheck = this.fullnameUnderbarCheck(this.userData.username, '登録名');
      if (!underbarCheck.status) {
        this.showErrorModal(underbarCheck.message);
        return;
      }
      // Only space check
      let onlySpaceChk = this.onlySpaceCheck(this.userData.username, '名前');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return;
      }
      onlySpaceChk = this.onlySpaceCheck(this.userData.departmentInfo, '部署');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return;
      }

      // Salesforceユーザ名チェック
      if (this.sfAuthInfo.userID) {
        // 特殊文字チェック
        if (this.hasSpecialCharacterInString(this.sfAuthInfo.userID)) {
          this.showErrorModal(messageContent.hasSpecialCharacter);
          return;
        }
        // 文字数チェック
        const sfUserIdLengthCheck = this.maxlengthCheck({
          target: 'Salesforceのユーザ名',
          maxlength: 50,
          content: this.sfAuthInfo.userID,
        });
        if (!sfUserIdLengthCheck.status) {
          this.showErrorModal(sfUserIdLengthCheck.message);
          return;
        }
        // SalesforceユーザIDのメールアドレス形式チェック
        if (!this.addressCheck(this.sfAuthInfo.userID)) {
          this.showErrorModal(messageContent.requireSalesforceEmail);
          return;
        }
      }
      // Salesforceパスワードチェック
      if (this.sfAuthInfo.password) {
        // 文字数チェック
        const sfUserPasswordLengthCheck = this.maxlengthCheck({
          target: 'Salesforceのパスワード',
          maxlength: 26000,
          content: this.sfAuthInfo.password,
        });
        if (!sfUserPasswordLengthCheck.status) {
          this.showErrorModal(sfUserPasswordLengthCheck.message);
          return;
        }
      }

      const sendData = {
        username: this.userData.username,
        authInfo: this.userData.authInfo,
        departmentInfo: this.userData.departmentInfo,
        clientName: this.userData.clientName,
        smsNumber: this.userData.smsNumber,
        sfUserID: this.sfAuthInfo.userID,
        sfPassword: this.sfAuthInfo.password,
      };
      if (this.isDAccountActive) {
        sendData.dAccountFlag = this.userData.dAccountFlag;

        // トライアルユーザはビジネスdアカウント連携不可
        if (this.userData.dAccountFlag && utils.chkTrialCompanyID(this.selectedCompanyID)) {
          this.showErrorModal(messageContent.canNotActiveDAccountForTrial());
          return;
        }

        if (this.userData.dAccountFlag && !this.canActiveDAccount) {
          this.showErrorModal(messageContent.canNotActiveDAccountDueToMailAuthenticating);
          return;
        }
        if (this.userData.dAccountFlag && this.userData.lockFlag) {
          this.showErrorModal(messageContent.canNotActiveDAccountDueToUserBlocked);
          return;
        }
      }

      const formDataTmp = {
        userID: this.userData.userID,
        companyID: this.selectedCompanyID,
        userData: sendData,
      };
      this.postRequest('/idmgmt/update', formDataTmp)
        .then(e => {
          if (e.status) {
            if (
              e.status === 'validationError' ||
              e.status === 'canNotActiveDAccount' ||
              e.status === 'canNotActiveDAccountForTrial'
            )
              return this.showErrorModal(e.msg);
            this.showUpdateInfoModal('設定を変更しました。');
            this.canResetPassword = !this.userData.dAccountFlag;
            this.userData.companyID = this.$store.state.user.companyID;
            if (this.$store.state.user.userID === this.userData.userID) {
              const loginInfo = {};
              Object.assign(loginInfo, this.userData);
              // Merge processed user data with user data in the store
              // Make sure updated data also update, and un-updated fields be kept in the store
              const storeUserData = this.$store.state.user;
              for (const key in storeUserData) {
                if (typeof loginInfo[key] === 'undefined' || loginInfo[key] === null) {
                  loginInfo[key] = storeUserData[key];
                }
              }
              this.updateLoginInfo(loginInfo);
            }
            return '';
          } else {
            return this.showErrorModal(messageContent.userInfoUpdateFailed);
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.userInfoUpdateFailed);
        });
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({ path: '/idmgmt', query: { companyID: this.selectedCompanyID } });
      } else {
        this.$router.push('/idmgmt');
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalMode = '';
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.saveSuccessFlag) {
        // 正常保存の場合、営業時間設定画面に遷移
        this.handleCancelClick();
      }
    },
    handlePasswordReset() {
      const formDataTmp = {
        userID: this.userData.userID,
        companyID: this.selectedCompanyID,
      };
      this.postRequest('/idmgmt/resetpassword', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            this.showInfoModal(messageContent.passwordEmailed);
          } else if (e.status === 'dAccountLinking') {
            this.showInfoModal(messageContent.canNotResetPasswordDueToDAccountLinking);
          } else {
            this.showErrorModal(messageContent.canNotResetPassword);
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.canNotResetPassword);
        });
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalMode = 'normal';
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalMode = 'normal';
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showUpdateInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalMode = 'normal';
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = true;
    },
    getSfAvailable: async function (userID, selectedCompanyID) {
      await this.postRequest('/idmgmt/checkSfAvailable', { userID: userID, selectedCompanyID: selectedCompanyID })
        .then(e => {
          if (e.data) {
            this.sfAvailable = e.data.sfAvailable;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>
